(function () {
  'use strict';

  var BAND_COLORS = {
    'black':        '#202020',
    'navy':         '#1e3868',
    'hunter':       '#375955',
    'hunter green': '#375955',
    'olive':        '#454411',
    'olive green':  '#454411',
    'fog':          '#C0C5D1',
    'fog grey':     '#C0C5D1',
    'white':        '#f5f3f0',
    'ice':          '#BEF1FA',
    'ice blue':     '#BEF1FA',
    'blush':        '#c9a09a',
    'rose':         '#D95C8C',
    'vibrant pink': '#e0207a',
    'coral':        '#e86070',
    'lavender':     '#9e86c0',
    'rust':         '#c04818',
    'poppy':        '#cc1e1e',
    'crimson':      '#8b1820',
    'mint':         '#5ab870'
  };

  var LIGHT_BAND_COLORS = ['white', 'ice', 'ice blue', 'blush', 'fog', 'fog grey'];

  // State
  var state = {
    name:           '',
    symbolEnabled:  false,
    symbolSrc:      '',
    symbolLabel:    '',
    isLight:        false
  };

  // DOM refs
  var root, bandLong, bandShort,
      nameDisplay, namePlaceholder,
      symbolDisplay, symbolPlaceholder,
      nameValue, symbolValue;

  function el(id) { return document.getElementById(id); }

  function init() {
    root = document.querySelector('[data-nsb-root]');
    if (!root) return;

    bandLong          = el('nsb-preview-band-long');
    bandShort         = el('nsb-preview-band-short');
    nameDisplay       = el('nsb-name-display');
    namePlaceholder   = el('nsb-name-placeholder');
    symbolDisplay     = el('nsb-symbol-display');
    symbolPlaceholder = el('nsb-symbol-placeholder');
    nameValue         = el('nsb-name-value');
    symbolValue       = el('nsb-symbol-value');

    bindNameInput();
    bindSymbolToggle();
    bindSymbolOptions();
    bindColorSync();

    var initialColor = detectCurrentColor();
    if (initialColor) applyBandColor(initialColor);

    renderPreview();
  }

  // --- Name input ---
  function bindNameInput() {
    var input = el('nsb-name-text');
    var counter = el('nsb-name-char-count');
    if (!input) return;
    input.addEventListener('input', function () {
      state.name = this.value;
      nameValue.value = this.value;
      if (counter) counter.textContent = this.value.length;
      renderName();
    });
  }

  // --- Symbol toggle ---
  function bindSymbolToggle() {
    var toggle = el('nsb-symbol-toggle');
    var fields = el('nsb-symbol-fields');
    if (!toggle || !fields) return;
    toggle.addEventListener('change', function () {
      state.symbolEnabled = this.checked;
      if (this.checked) {
        fields.removeAttribute('hidden');
      } else {
        fields.setAttribute('hidden', '');
        state.symbolSrc = '';
        state.symbolLabel = '';
        symbolValue.value = '';
        root.querySelectorAll('.cb-symbol-option').forEach(function (b) {
          b.classList.remove('is-selected');
        });
      }
      renderSymbol();
    });
  }

  // --- Symbol options (single-select across all groups) ---
  function bindSymbolOptions() {
    var options = root.querySelectorAll('.cb-symbol-option');
    options.forEach(function (opt) {
      opt.addEventListener('click', function () {
        options.forEach(function (o) { o.classList.remove('is-selected'); });
        opt.classList.add('is-selected');
        state.symbolSrc = opt.dataset.iconSrc;
        state.symbolLabel = opt.dataset.iconLabel;
        symbolValue.value = state.symbolLabel;
        renderSymbol();
      });
    });
  }

  // --- Color sync ---
  function detectCurrentColor() {
    var radios = document.querySelectorAll('input[type="radio"]:checked');
    for (var i = 0; i < radios.length; i++) {
      var v = radios[i].value.toLowerCase();
      if (BAND_COLORS[v]) return v;
    }
    var selects = document.querySelectorAll('variant-selects select, .product-form select');
    for (var j = 0; j < selects.length; j++) {
      var v2 = selects[j].value.toLowerCase();
      if (BAND_COLORS[v2]) return v2;
    }
    return null;
  }

  function applyBandColor(colorName) {
    var hex = BAND_COLORS[colorName];
    if (!hex) return;
    if (bandLong)  bandLong.style.backgroundColor  = hex;
    if (bandShort) bandShort.style.backgroundColor = hex;

    state.isLight = LIGHT_BAND_COLORS.indexOf(colorName) !== -1;
    var textColor = state.isLight ? 'rgba(0,0,0,0.45)' : 'rgba(255,255,255,0.8)';

    if (nameDisplay) nameDisplay.style.color = textColor;

    if (symbolDisplay) {
      if (state.isLight) {
        symbolDisplay.style.filter = '';
        symbolDisplay.style.mixBlendMode = 'multiply';
      } else {
        symbolDisplay.style.filter = 'invert(1)';
        symbolDisplay.style.mixBlendMode = 'screen';
      }
    }
  }

  function bindColorSync() {
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (t.type === 'radio' || t.tagName === 'SELECT') {
        var v = t.value.toLowerCase();
        if (BAND_COLORS[v]) {
          applyBandColor(v);
        } else {
          var found = detectCurrentColor();
          if (found) applyBandColor(found);
        }
      }
    });
  }

  // --- Render functions ---
  function renderName() {
    if (!nameDisplay || !namePlaceholder) return;
    if (state.name.length > 0) {
      nameDisplay.textContent = state.name;
      nameDisplay.style.display = 'inline';
      namePlaceholder.style.display = 'none';
    } else {
      nameDisplay.style.display = 'none';
      namePlaceholder.style.display = 'inline';
    }
  }

  function renderSymbol() {
    if (!symbolDisplay || !symbolPlaceholder) return;
    if (state.symbolEnabled && state.symbolSrc) {
      symbolDisplay.src = state.symbolSrc;
      symbolDisplay.alt = state.symbolLabel;
      symbolDisplay.style.display = 'block';
      symbolPlaceholder.style.display = 'none';
    } else {
      symbolDisplay.style.display = 'none';
      symbolPlaceholder.style.display = 'inline';
    }
  }

  function renderPreview() {
    renderName();
    renderSymbol();
  }

  // Boot
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
